import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PageHeader1 from "../../components/common/PageHeader1";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import st from "./DynamicForm.module.scss";

import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import { GetScreenListApi,handleDeleteScreen } from "../../services/Introscreen";


function ScreenList() {
  const navigate = useNavigate();

 

  const [getUserData, setgetUserData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [userList, setUserList] = useState([]);

  const { reset } = useForm();


  const getFilter = (data) => {
   
    setgetUserData(data)
  }

 

  const columns = () => {
    return [
      {
        field: "sno",
        headerName: "S.No.",
        sortable: true,
        width: 100,
      },
      {
        field: "image",
        headerName: "Image",
        width: 100,
        renderCell: (params) => (
          <img
            src={`${params.row.image}`}
            alt="recipe"
            style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 8 }}
          />
        ),
      },
      {
        field: "title",
        headerName: "Title",
        sortable: true,
        width: 200,
      },
      {
        field: "subtitle",
        headerName: "Sub Title",
        sortable: true,
        width: 200,
      },

      {
        field: "action",
        headerName: "ACTION",
        sortable: false,
        width: 100,
        renderCell: (params) => (
          console.log("params", params),
          <div className="btn-group">
            {/* 
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => {
                getFilter(params.row)
              }}
            >
              <i className="icofont-eye-alt"></i>
            </button>
            */}
            {/* 👉 Edit Button */}
            <button
              type="button"
              className="btn btn-outline-primary ms-2 mt-2"
              onClick={() => navigate(`/edit-screens/${params.row._id}`)}
            >
              <i className="icofont-ui-edit"></i>
            </button>
            
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={() => handleDeleteScreen(params.row._id,getScreenList)}
            >
              <i className="icofont-ui-delete"></i>
            </button>
            
          </div>
        ),
      },
    ]
  };

  async function getScreenList() {
    setIsLoading(true);
    try {
      const response = await GetScreenListApi();
      const { data } = await response; // Assuming data is the array of users
      console.log("Screen List Data:", data);
  
      setUserList(
        data?.map((item, i) => {
          return {
            ...item,
            id: item?._id,
            sno: i + 1
          };
        }) || [] // Ensure setUserList gets an array even if data is null/undefined
      );
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      reset();
      setIsLoading(false);
    }
  }  

  const clearData = () => {
    setgetUserData({});
   
  }

  useEffect(() => {
    getScreenList()
  }, [])

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1
          pagetitle="Screen Information"
          modalbutton={() => {
            return (
              <div className="col-auto d-flex w-sm-100">
                <button
                  type="button"
                  className="btn btn-primary btn-set-task w-sm-100"
                  onClick={() => navigate("/create-screens")}
                >
                  <i className="icofont-plus-circle me-2 fs-6"></i>Add Screen
                </button>
              </div>
            );
          }}
        />

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <div
                  id="myProjectTable_wrapper"
                  className="dataTables_wrapper dt-bootstrap5 no-footer"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      {userList && <DataGrid
                        rows={userList}
                        columns={columns()}
                        loading={isLoading}
                        pagination
                        initialState={{
                          ...userList.initialState,
                          pagination: { paginationModel: { pageSize: 8} },
                        }}
                        pageSizeOptions={[8, 10, 25, { value: -1, label: 'All' }]}
                        sx={{
                          border: "none",
                          "& .MuiDataGrid-root": {
                            border: "none",
                          },
                        }}
                      />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


   

    </div>
  );
}
export default ScreenList;
